import { useQuery } from "@tanstack/vue-query";
import { computed, MaybeRef, toRef } from "vue";

import KiliApi from "@/data/api/kili/kili-api";
import { SitesQueryKeys } from "@/data/api/kili/sites/sites-query-keys";

export function useGetSiteInstalledApplianceCategoriesQuery(siteId: MaybeRef<number>) {
  const _siteId = toRef(siteId);

  return useQuery({
    queryKey: SitesQueryKeys.installedApplianceCategories(_siteId),
    queryFn: async () => KiliApi.getSiteInstalledApplianceCategories({ params: { siteId: _siteId.value } }),
    enabled: computed(() => _siteId.value > 0),
  });
}
